"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendPlugin = void 0;
var eos = ['telos', 'telos-testnet'];
var Blockchain = {
    eos: eos,
};
exports.appendPlugin = function (blockchain) {
    var e_1, _a;
    var keys = Object.keys(Blockchain);
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            var nameSet = Blockchain[key];
            if (nameSet.find(function (n) { return n === blockchain.name; })) {
                return __assign(__assign({}, blockchain), { plugin: key });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var plugin = blockchain.plugin;
    if (!plugin) {
        throw new Error("Cannot find 'plugin' property for your custom 'blockchain' configuration.");
    }
    return blockchain;
};
exports.default = Blockchain;
